/**
 * Mobile-responsive wrappers for credits, purchases, payments, sales, stocks.
 * Full path: /mobile/...
 */
const m = {
  auth: { is_auth: true, is_admin: true, layout: "dashboard" },
};

export const mobileModuleChildren = [
  // —— Credits ——
  {
    path: "credits/index",
    name: "mobile-credits-index",
    meta: { ...m.auth, title: "Crédits clients" },
    component: () => import("@/views/mobiles/credits/Listing.vue"),
  },
  {
    path: "credits/create",
    name: "mobile-credits-create",
    meta: { ...m.auth, title: "Crédit" },
    component: () => import("@/views/mobiles/credits/Create.vue"),
  },
  {
    path: "credits/suppliers/index",
    name: "mobile-credits-suppliers-index",
    meta: { ...m.auth, title: "Crédits fournisseurs" },
    component: () => import("@/views/mobiles/credits/suppliers/Listing.vue"),
  },
  {
    path: "credits/suppliers/balance",
    name: "mobile-credits-suppliers-balance",
    meta: { ...m.auth, title: "Soldes fournisseurs" },
    component: () => import("@/views/mobiles/credits/suppliers/Balance.vue"),
  },
  {
    path: "credits/suppliers/create",
    name: "mobile-credits-suppliers-create",
    meta: { ...m.auth, title: "Crédit fournisseur" },
    component: () => import("@/views/mobiles/credits/suppliers/Create.vue"),
  },
  {
    path: "credits/balances/index",
    name: "mobile-credits-balances",
    meta: { ...m.auth, title: "Soldes créditeurs" },
    component: () => import("@/views/mobiles/credits/Balance.vue"),
  },
  {
    path: "credits/balances/:customer_reference/all",
    name: "mobile-credits-balances-all",
    meta: { ...m.auth, title: "Détail soldes" },
    component: () => import("@/views/mobiles/credits/BalanceDetails.vue"),
  },

  // —— Purchases (static paths before :reference) ——
  {
    path: "purchases/index",
    name: "mobile-purchases-index",
    meta: { ...m.auth, title: "Achats" },
    component: () => import("@/views/mobiles/purchases/Listing.vue"),
  },
  {
    path: "purchases/create",
    name: "mobile-purchases-create",
    meta: { ...m.auth, title: "Nouvel achat" },
    component: () => import("@/views/mobiles/purchases/Create.vue"),
  },
  {
    path: "purchases/noticed/index",
    name: "mobile-purchases-noticed-index",
    meta: { ...m.auth, title: "Achats remarqués" },
    component: () => import("@/views/mobiles/purchases/Noticed.vue"),
  },
  {
    path: "purchases/tovalidate/index",
    name: "mobile-purchases-tovalidate-index",
    meta: { ...m.auth, title: "Achats à valider" },
    component: () => import("@/views/mobiles/purchases/ToValidate.vue"),
  },
  {
    path: "purchases/supplier/report",
    name: "mobile-purchases-supplier-report",
    meta: { ...m.auth, title: "Rapport fournisseur" },
    component: () => import("@/views/mobiles/purchases/SupplierReport.vue"),
  },
  {
    path: "purchases/items/create",
    name: "mobile-purchases-items-create",
    meta: { ...m.auth, title: "Article achat" },
    component: () => import("@/views/mobiles/purchases/items/Create.vue"),
  },
  {
    path: "purchases/items/search",
    name: "mobile-purchases-items-search",
    meta: { ...m.auth, title: "Recherche articles" },
    component: () => import("@/views/mobiles/purchases/items/Search.vue"),
  },
  {
    path: "purchases/:reference/details",
    name: "mobile-purchases-details",
    meta: { ...m.auth, title: "Détail achat" },
    component: () => import("@/views/mobiles/purchases/Details.vue"),
  },
  {
    path: "purchases/:reference/edit",
    name: "mobile-purchases-edit",
    meta: { ...m.auth, title: "Modifier achat" },
    component: () => import("@/views/mobiles/purchases/Edit.vue"),
  },
  {
    path: "purchases/:reference/items/edit",
    name: "mobile-purchases-items-edit",
    meta: { ...m.auth, title: "Modifier article" },
    component: () => import("@/views/mobiles/purchases/items/Edit.vue"),
  },

  // —— Payments ——
  {
    path: "payments/customers/index",
    name: "mobile-payments-customers-index",
    meta: { ...m.auth, title: "Paiements clients" },
    component: () => import("@/views/mobiles/payments/Listing.vue"),
  },
  {
    path: "payments/customers/create",
    name: "mobile-payments-customers-create",
    meta: { ...m.auth, title: "Nouveau paiement" },
    component: () => import("@/views/mobiles/payments/Create.vue"),
  },
  {
    path: "payments/customers/:reference/edit",
    name: "mobile-payments-customers-edit",
    meta: { ...m.auth, title: "Modifier paiement" },
    component: () => import("@/views/mobiles/payments/Edit.vue"),
  },
  {
    path: "payments/customers/:reference/details",
    name: "mobile-payments-customers-details",
    meta: { ...m.auth, title: "Détail paiement" },
    component: () => import("@/views/mobiles/payments/Details.vue"),
  },
  {
    path: "payments/suppliers/index",
    name: "mobile-payments-suppliers-index",
    meta: { ...m.auth, title: "Paiements fournisseurs" },
    component: () => import("@/views/mobiles/payments/suppliers/Listing.vue"),
  },
  {
    path: "payments/suppliers/create",
    name: "mobile-payments-suppliers-create",
    meta: { ...m.auth, title: "Paiement fournisseur" },
    component: () => import("@/views/mobiles/payments/suppliers/Create.vue"),
  },
  {
    path: "payments/suppliers/:reference/edit",
    name: "mobile-payments-suppliers-edit",
    meta: { ...m.auth, title: "Modifier paiement fourn." },
    component: () => import("@/views/mobiles/payments/suppliers/Edit.vue"),
  },
  {
    path: "payments/suppliers/:reference/details",
    name: "mobile-payments-suppliers-details",
    meta: { ...m.auth, title: "Détail paiement fourn." },
    component: () => import("@/views/mobiles/payments/suppliers/Details.vue"),
  },
  {
    path: "payments/suppliers/noticed",
    name: "mobile-payments-suppliers-noticed",
    meta: { ...m.auth, title: "Paiem. fourn. remarqués" },
    component: () => import("@/views/mobiles/payments/suppliers/Noticed.vue"),
  },
  {
    path: "payments/suppliers/tovalidate",
    name: "mobile-payments-suppliers-tovalidate",
    meta: { ...m.auth, title: "Paiem. fourn. à valider" },
    component: () => import("@/views/mobiles/payments/suppliers/ToValidate.vue"),
  },
  {
    path: "payments/repairs/index",
    name: "mobile-payments-repairs-index",
    meta: { ...m.auth, is_repair: true, title: "Paiements réparations" },
    component: () => import("@/views/mobiles/payments/repairs/Listing.vue"),
  },
  {
    path: "payments/repairs/create",
    name: "mobile-payments-repairs-create",
    meta: { ...m.auth, is_repair: true, title: "Paiement réparation" },
    component: () => import("@/views/mobiles/payments/repairs/Create.vue"),
  },
  {
    path: "payments/repairs/:reference/edit",
    name: "mobile-payments-repairs-edit",
    meta: { ...m.auth, is_repair: true, title: "Modifier paiement rép." },
    component: () => import("@/views/mobiles/payments/repairs/Edit.vue"),
  },
  {
    path: "payments/repairs/:reference/details",
    name: "mobile-payments-repairs-details",
    meta: { ...m.auth, is_repair: true, title: "Détail paiement rép." },
    component: () => import("@/views/mobiles/payments/repairs/Details.vue"),
  },
  {
    path: "payments/checks",
    name: "mobile-payments-checks",
    meta: { ...m.auth, title: "Chèques" },
    component: () => import("@/views/mobiles/payments/Checks.vue"),
  },
  {
    path: "payments/noticed",
    name: "mobile-payments-noticed",
    meta: { ...m.auth, title: "Paiements remarqués" },
    component: () => import("@/views/mobiles/payments/Noticed.vue"),
  },
  {
    path: "payments/tovalidate",
    name: "mobile-payments-tovalidate",
    meta: { ...m.auth, title: "Paiements à valider" },
    component: () => import("@/views/mobiles/payments/ToValidate.vue"),
  },

  // —— Sales ——
  {
    path: "sales/index",
    name: "mobile-sales-index",
    meta: { ...m.auth, title: "Ventes" },
    component: () => import("@/views/mobiles/sales/Listing.vue"),
  },
  {
    path: "sales/create",
    name: "mobile-sales-create",
    meta: { ...m.auth, title: "Nouvelle vente" },
    component: () => import("@/views/mobiles/sales/Create.vue"),
  },
  {
    path: "sales/noticed/index",
    name: "mobile-sales-noticed-index",
    meta: { ...m.auth, title: "Ventes remarquées" },
    component: () => import("@/views/mobiles/sales/Noticed.vue"),
  },
  {
    path: "sales/items/create",
    name: "mobile-sales-items-create",
    meta: { ...m.auth, title: "Article vente" },
    component: () => import("@/views/mobiles/sales/items/Create.vue"),
  },
  {
    path: "sales/:reference/details",
    name: "mobile-sales-details",
    meta: { ...m.auth, title: "Détail vente" },
    component: () => import("@/views/mobiles/sales/Details.vue"),
  },
  {
    path: "sales/:reference/edit",
    name: "mobile-sales-edit",
    meta: { ...m.auth, title: "Modifier vente" },
    component: () => import("@/views/mobiles/sales/Edit.vue"),
  },
  {
    path: "sales/:reference/items/edit",
    name: "mobile-sales-items-edit",
    meta: { ...m.auth, title: "Modifier article vente" },
    component: () => import("@/views/mobiles/sales/items/Edit.vue"),
  },

  // —— Stocks ——
  {
    path: "stocks/index",
    name: "mobile-stocks-index",
    meta: { ...m.auth, title: "État de stock" },
    component: () => import("@/views/mobiles/stocks/Listing.vue"),
  },
  {
    path: "stocks/out/index",
    name: "mobile-stocks-out-index",
    meta: { ...m.auth, title: "Rupture de stock" },
    component: () => import("@/views/mobiles/stocks/OutStock.vue"),
  },
  {
    path: "stocks/transfer/quantity",
    name: "mobile-stocks-transfer-quantity",
    meta: { ...m.auth, title: "Transfert quantité" },
    component: () => import("@/views/mobiles/stocks/transferQuantity.vue"),
  },
  {
    path: "stocks/statistics/index",
    name: "mobile-stocks-statistics-index",
    meta: { ...m.auth, title: "Statistiques stock" },
    component: () => import("@/views/mobiles/stocks/Statistics.vue"),
  },
  {
    path: "stocks/designations/index",
    name: "mobile-stocks-designations-index",
    meta: { ...m.auth, title: "Désignations" },
    component: () => import("@/views/mobiles/stocks/designations/Listing.vue"),
  },
  {
    path: "stocks/designations/create",
    name: "mobile-stocks-designations-create",
    meta: { ...m.auth, title: "Nouvelle désignation" },
    component: () => import("@/views/mobiles/stocks/designations/Create.vue"),
  },
  {
    path: "stocks/designations/:reference/edit",
    name: "mobile-stocks-designations-edit",
    meta: { ...m.auth, title: "Modifier désignation" },
    component: () => import("@/views/mobiles/stocks/designations/Edit.vue"),
  },
  {
    path: "stocks/item/:itemReference/create",
    name: "mobile-stocks-create",
    meta: { ...m.auth, title: "Ajout stock" },
    component: () => import("@/views/mobiles/stocks/Create.vue"),
  },
  {
    path: "stocks/:reference/edit",
    name: "mobile-stocks-edit",
    meta: { ...m.auth, title: "Modifier stock" },
    component: () => import("@/views/mobiles/stocks/Edit.vue"),
  },
  {
    path: "stocks/:reference/delete",
    name: "mobile-stocks-delete",
    meta: { ...m.auth, title: "Supprimer stock" },
    component: () => import("@/views/mobiles/stocks/Delete.vue"),
  },
];
